import React from "react";
import { useSelector } from "react-redux";

import { ProfileImage } from "./Helper";
import Link from "../Link";
import Title from "../Title";

import style from "./style.module.css";

export default function ProfilePhoto({ size = "" }) {
    const userProfile = useSelector((state) => state.storage.data);
    const firstName = userProfile.first_name;
    const fname = firstName ? firstName.substring(0, 1) : '';
    let profileImage = null;

    if (userProfile.image_name !== null && userProfile.image_name !== "" && userProfile.image_name !== undefined) {
        profileImage = ProfileImage(userProfile.image_name, userProfile.image_path);
    }

    return (
        <>
            {
                fname !== "" && (
                    <Link to={"/profile"} className={style.profileImage}>
                        <div className={`${style.profile} ${size !== "" ? style[size] : ""}`}>
                            <div className={style.placeholder}>
                                {
                                    profileImage !== null && profileImage !== "" && (
                                        <img alt="profile_image" src={`${process.env.REACT_APP_API_URL}/account/image`} key={profileImage} />
                                    )
                                }
                                {
                                    (profileImage === null || profileImage === "") && (
                                        <Title tag={"h6"}>{fname}</Title>
                                    )
                                }
                            </div>
                        </div>
                    </Link>
                )
            }
        </>
    )
}